var render, staticRenderFns
import script from "./LocaleDateTimeInput.vue?vue&type=script&lang=js"
export * from "./LocaleDateTimeInput.vue?vue&type=script&lang=js"
import style0 from "./LocaleDateTimeInput.vue?vue&type=style&index=0&id=2b4f5b82&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports